import { giphyDarkestGrey } from '@giphy/colors'
import styled from 'styled-components'
import { Alert as AlertComponent } from 'ui/src/components/alert'
import ButtonComponent from 'ui/src/components/controls/button'

export const Alert = styled(AlertComponent)`
    background: ${giphyDarkestGrey};
    border: none;
    width: 100%;
`

export const Button = styled(ButtonComponent)`
    display: inline-block;
    margin-right: 10px;
    width: 170px;

    svg,
    i {
        margin: -2px -10px 0 10px;
        vertical-align: middle;
    }

    &:last-child {
        margin-right: 0;
    }
`
